const WORK = [
  {
    name: 'SLATE',
    video: 'spotify-redesign.mp4',
    poster: 'spotify-redesign.jpg',
    description:
      '<p>Designers need fast prototypes, with the ability to test different models rapidly. Software is a commodity now, just like any visual asset. Why can\'t it feel like storyboarding?</p>',
    stack: 'A new IDE for designers',
    summary: 'A new IDE for designers',
    date: '10.2026',
  },
  {
    name: 'index',
    images: ['iindex.webp'],
    imageAspectRatio: '1508 / 770',
    imageObjectPosition: 'center top',
    description:
      '<p>I built index as a way for people to generate clean, beautiful data visualizations. Users can share them to the social feed, making data a more explorable form of storytelling.</p>',
    stack: 'React • D3.js • Cloudflare Agents SDK',
    summary: 'A public feed of data visualizations and charts.',
    date: '06.2026',
    link: 'https://iindex.co/',
  },
  {
    name: 'Visual Agent',
    video: 'visual-agent-chat.mp4',
    poster: 'visual-agent-chat.jpg',
    description:
      '<p>Why <em>don\'t</em> we visualize agent thinking?</p>',
    stack: 'Claude Code prototype',
    summary: 'A visual interface for watching an AI agent think and make.',
    date: '10.2026',
  },
  {
    name: 'needle drop recs',
    images: ['needledrop/landing.png'],
    imageAspectRatio: '3024 / 1712',
    imageObjectPosition: 'center center',
    description:
      '<p>I\'ve been watching The Needle Drop since I was 12, and I\'ve gotten more music recs from him than Spotify or Apple Music. The conversation around "taste" signifies we\'ll begin to re-value humans who have built-up credibility — artisans — over algorithms in this next digital age.</p><p>This site is a music recommendation engine powered solely by The Needle Drop\'s recs - no ML.</p>',
    stack: 'Python • JavaScript • Cloudflare Workers • SQLite • Spotify API',
    summary: 'Discover music from the internet\'s busiest music nerd.',
    date: '10.2026',
    link: 'https://www.needledrop-recs.com/',
  },
  {
    name: 'Dojo Notes',
    images: ['dojonotes.webp'],
    imageAspectRatio: '1508 / 800',
    imageObjectPosition: 'center center',
    description:
      '<p>The linear chat interface has not been iterated on since 2022. Dojo is a visual AI workspace where you can drop in PDFs, websites, videos, and images.</p>',
    stack: 'React • Node.js • AI APIs',
    summary: 'An AI workspace for organizing and querying your knowledge.',
    date: '05.2026',
    link: 'https://www.dojonotes.com/',
  },
  {
    name: 'Replicate Agent',
    images: ['replicate-agent-screenshot.png'],
    imageAspectRatio: '1508 / 800',
    imageObjectPosition: 'center center',
    description:
      '<p>A conversational AI agent that generates images, videos, music, and more by chatting with Replicate\'s model library. Powered by Cloudflare Workers and the Agents SDK.</p>',
    stack: 'Cloudflare Workers • Replicate API • AI SDK',
    summary: 'Chat-based AI generation agent built on Replicate.',
    date: '04.2026',
    link: 'https://agent.replicate.workers.dev/',
  },
  {
    name: 'Image Editing Arena',
    images: ['arena.webp'],
    description:
      '<p>Image Editing Arena is a platform for users to edit images using the latest image models. Powered by Replicate.</p>',
    stack: 'React • Tailwind CSS • Replicate API',
    summary: 'Image Editing Arena is a platform for users to edit images using AI.',
    date: '11.2025',
    link: 'https://x.com/replicate/status/1993740895989191141/video/1',
  },
  {
    name: 'FLORA: Mobile',
    images: ['landing.webp', 'loading.webp', 'minecraft.webp'],
    description:
      '<p> Developed FLORA\'s mobile landing page which features a realtime AI filter where users can transform their face by typing their own prompts. This is done through a Stream Diffusion pipeline hosted on a Modal container in the backend.</p>',
    stack: 'React • JavaScript • HTML/CSS • PostgreSQL • Modal • Python',
    summary:
      'FLORA is an infinite AI canvas - I made their landing page and am working as a backend engineer',
    date: '04.2024',
    link: 'https://florafauna.ai',
  },
  {
    name: 'CAD Autolabeling',
    images: ['captionable-canny.webp'],
    description:
      '<p>At Autodesk Research, I developed autolabeling technology for CAD files uploaded to the Autodesk Viewer platform. </br> </br> I learned how to host pre-trained language models (BLIP, BLIP-2, CLIP) using Salesforce Lavis and design experimentation pipelines to finetune them on company data using PyTorch manipulation and LoRA configs. Additionally, I worked with PyTorch DDP to run multiple model replicas in parallel for rapid caption generation.</p>',
    stack: 'Python • PyTorch • BLIP-2 • CLIP • LoRA finetuning • pandas',
    summary:
      'Autolabeling technology for CAD files uploaded to the Autodesk Viewer.',
    date: '04.2024',
    link: 'https://medium.com/@shridharathi/employing-pretrained-vision-and-language-models-to-auto-label-cad-files-d872cad2299a/',
  },
  
  {
    name: 'Art Classifier',
    images: ['art.webp'],
    description:
      '<p>Historical art classification serves as an engaging topic within the digital humanities given the vast, rich visual and textual data involved. Most research has classified art pieces by artist and style, but there is little to no prior work on classification by medium. We utilize various Convolutional Neural Network (CNN) architectures (mostly variations of ResNet) as platforms for experimentation to ultimately develop and fine-tune a high performing medium classification paradigm. Using data from Tate collection involving British artwork from 1500 to the present and models ranging from a rudimentary CNN to ResNet18 paired with data augmentation and frozen gradients, our strongest model obtained an overall test accuracy of 74.9%. We also showcase interesting discussion on binary classification through medium tagging. Ultimately, these results showcase the power of CNNs in medium classification, signifying their abilities of learning representational characteristics of various media</p>',
    stack: 'Python • Pytorch • numpy • scikit-learn • ResNet18',
    summary:
      'Historical art classification',
    date: '04.2022',
    link: 'https://cs231n.stanford.edu/reports/2022/pdfs/135.pdf',
  },

  {
    name: 'Pune Water',
    images: ['pune.webp', 'pune2.webp'],
    stack: 'Python • pandas • OpenCV • ArcGIS • Illustrator API',
    description:
      "<p>No major city in India has a 24x7 piped water supply system. Pune in Maharashtra, India has plans to be among the first, and yet, it faces a mismatch between available piped water supply and demand for potable water. In this modeling study, we investigate the degree to which Pune’s current intermittent water supply system (IWS) contributes to this. Over 94% of Pune homes are serviced, yet approximately 30-40% of water is lost to leakage and mismanagement under the IWS. This study compares a 24x7 water distribution system (WDS) with an intermittent system to quantify the gains in water supply and changes in equity among different urban users from high-income households to slum-dwellings. Using data supplied by the Pune Municipal Corporation, a hydraulic model of the current WDS was digitized with the Water Network Tool for Resilience (WNTR). EPAnet engine simulations were conducted and alterations to the existing IWS were made to transform the system to a 24x7 water supply model. Our results have implications for water resources planning, management, and climate resiliency as they reveal the tradeoffs and advantages of each type of water distribution system. Quantifying the potential benefits helps municipalities in Pune as they weigh costs of investing in continuous water supply against the inequities which characterize intermittency.</p>",
    summary:
      'Modeling study on water distribution in Pune, India.',
    date: '04.2020',
    link: 'https://agu.confex.com/agu/fm20/meetingapp.cgi/Paper/735906',
  },
];

export default WORK;
